import modalFormTemplate from './modal_form.html';

import NewFormCtrl from './new_form.controller';
import EditFormCtrl from './edit_form.controller';
import BookFromCtrl from './book_form.controller';

function ModalForm($uibModal) {
    'ngInject';

    return {
        new(config) {
            let templateUrl;
            if (config.templateUrl) {
                ({templateUrl} = config);
            }
            if (!templateUrl) {
                templateUrl = modalFormTemplate.id;
            }
            return $uibModal.open({
                keyboard: false,
                templateUrl,
                controller: NewFormCtrl,
                size: config.size,
                resolve: {
                    company() {
                        return config.company || config.base;
                    },
                    title() {
                        return config.title;
                    },
                    new_rel() {
                        return config.new_rel;
                    },
                    post_rel() {
                        return config.post_rel;
                    },
                    successFn() {
                        return config.success;
                    },
                    failFn() {
                        return config.fail;
                    },
                    init_model() {
                        return config.init_model;
                    },
                    before_submit() {
                        return config.before_submit;
                    },
                    params() {
                        return config.params || {};
                    }
                }
            });
        },

        edit(config) {
            let templateUrl;
            if (config.templateUrl) {
                ({templateUrl} = config);
            }
            if (!templateUrl) {
                templateUrl = modalFormTemplate.id;
            }
            return $uibModal.open({
                keyboard: false,
                templateUrl,
                controller: EditFormCtrl,
                size: config.size,
                resolve: {
                    model() {
                        return config.model;
                    },
                    title() {
                        return config.title;
                    },
                    successFn() {
                        return config.success;
                    },
                    failFn() {
                        return config.fail;
                    },
                    params() {
                        return config.params || {};
                    },
                    enforceTimeZoneFn() {
                        return config.enforceTimeZoneFn;
                    },
                    determineTimeZoneFn() {
                        return config.determineTimeZoneFn;
                    },
                    onDismissFn() {
                        return config.onDismissFn;
                    }
                }
            });
        },

        book(config) {
            let templateUrl;
            if (config.templateUrl) {
                ({templateUrl} = config);
            }
            if (!templateUrl) {
                templateUrl = modalFormTemplate.id;
            }
            return $uibModal.open({
                keyboard: false,
                templateUrl,
                controller: BookFromCtrl,
                size: config.size,
                resolve: {
                    model() {
                        return config.model;
                    },
                    company() {
                        return config.company;
                    },
                    title() {
                        return config.title;
                    },
                    successFn() {
                        return config.success;
                    },
                    failFn() {
                        return config.fail;
                    }
                }
            });
        }
    };
}

angular
    .module('BB')
    .service('ModalForm', ModalForm);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/modal_form/modal_form.service.js